import { createSelector } from 'reselect';
import { createGenericOptionsSelector } from '../helpers/reduxHelpers';
import { UNINITIALIZED, SUCCEEDED } from 'ContentUtils/constants/RequestStatus';
const getAppStores = state => {
  var _state$resources$ecom;
  return ((_state$resources$ecom = state.resources.ecommerce) === null || _state$resources$ecom === void 0 ? void 0 : _state$resources$ecom.appStores) || {};
};
export const getAppStore = (state, props) => getAppStores(state)[props.appId];
const getStoreAccountId = (state, props) => props.storeAccountId;
export const getSelectedStore = createSelector([getAppStore, getStoreAccountId], (appStore, storeAccountId) => {
  var _appStore$enabledStor;
  return storeAccountId ? appStore === null || appStore === void 0 || (_appStore$enabledStor = appStore.enabledStores) === null || _appStore$enabledStor === void 0 ? void 0 : _appStore$enabledStor.find(store => store.dataSyncAccountId === storeAccountId) : undefined;
});
export const getObjectsCache = (state, props) => state.resources.ecommerce.objectsCache[props.objectType] || {};
export const getObjects = (state, props) => {
  return state.resources.ecommerce.objects[props.objectType] || {};
};
export const getObject = (state, props) => {
  return props.objectId ? getObjects(state, props)[props.objectId] : undefined;
};
export const getObjectCache = (state, props) => {
  return props.objectId && getObjectsCache(state, props)[props.objectId];
};
export const getObjectsOptions = createGenericOptionsSelector(getObjectsCache);
export const getDefaultObjectsOptions = createGenericOptionsSelector(getObjects);
export const getStoresFetchRequestStatus = state => {
  return state.resources.ecommerce.requestStatus;
};
export const getHasNoStores = createSelector([getStoresFetchRequestStatus, getAppStore], (requestStatus, appStore) => {
  var _appStore$enabledStor2;
  return requestStatus === SUCCEEDED && !(appStore !== null && appStore !== void 0 && (_appStore$enabledStor2 = appStore.enabledStores) !== null && _appStore$enabledStor2 !== void 0 && _appStore$enabledStor2.length);
});
export const getObjectFetchRequestStatus = (state, props) => {
  var _state$resources$ecom2;
  return ((_state$resources$ecom2 = state.resources.ecommerce.objectsRequestStatus[props.objectType]) === null || _state$resources$ecom2 === void 0 ? void 0 : _state$resources$ecom2[props.objectId]) || UNINITIALIZED;
};